import o from "./ghl-ui.es1443.js";
import t from "./ghl-ui.es1444.js";
import r from "./ghl-ui.es1445.js";
import a from "./ghl-ui.es1446.js";
import m from "./ghl-ui.es1447.js";
var e = {
  code: "hr",
  formatDistance: o,
  formatLong: t,
  formatRelative: r,
  localize: a,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const s = e;
export {
  s as default
};
